import dayjs from 'dayjs'
import { useRecordContext, useReference } from 'react-admin'
import { AritcleAuthor } from '../../AritcleAuthor'
import { PromotionAuthorProps } from './type'
import { imageUrlConcat } from '../../../utils/url-concat'
import { styled, Chip, Box } from '@mui/material'

const CardChipContainer = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'end',
  
})

const StyledChip = styled(Chip)(({ theme }) => ({
  color: theme.palette.common.white,
  fontWeight: 600,
  transition: `opacity ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}`,
  '&:hover': {
    opacity: 0,
  },
}))

const MaxCardChip = <StyledChip label='Max Card' sx={{ bgcolor: 'error.main' }} />
const CreditCardChip = <StyledChip label='Credit Card' sx={{ bgcolor: 'info.main' }} />
const NoCardChip = <StyledChip label='Normal' sx={{ color: 'text.primary' }} />

const Container = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
});

const PromotionAritcleAuthor = styled(AritcleAuthor)({
  width: '100%',
});

export const PromotionAuthor: React.FC<PromotionAuthorProps> = ({ authorSource, dateSource, ...props }) => {
  const record = useRecordContext()
  const { referenceRecord, isLoading } = useReference({
    reference: 'admins',
    id: record[authorSource],
  })
  const avatarPath = referenceRecord ? imageUrlConcat(referenceRecord?.avatar?.full_path) : ''
  const dateFomatted = record[dateSource] ? dayjs(record[dateSource]).format('D MMMM YYYY') : null
  const isMaxCard = record.is_max_card
  const isCreditCard = record.is_credit_card
  const NoCard = !isMaxCard && !isCreditCard

  return (
    !isLoading && (
      <Container>
        <PromotionAritcleAuthor
          image={avatarPath}
          name={referenceRecord?.name}
          date={dateFomatted}
          {...props}
        />
          <CardChipContainer style={{gap: '0.5em'}}>
          {isMaxCard && MaxCardChip}
          {isCreditCard && CreditCardChip}
          {NoCard && NoCardChip}
        </CardChipContainer>
      </Container>  
    )
  )
}
